import { useState, useEffect } from "react";
import { db } from "../firebase";
import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  doc,
  updateDoc,
} from "firebase/firestore";

import "./AdminDashboard.css";

const CLOUD_NAME = "drsuny5rd";
const UPLOAD_PRESET = "products_upload";

const AdminDashboard = () => {
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [description, setDescription] = useState("");

  const [mainImage, setMainImage] = useState("");
  const [image2, setImage2] = useState("");
  const [image3, setImage3] = useState("");

  const [uploading, setUploading] = useState(false);

  const [products, setProducts] = useState([]);

  const [editingId, setEditingId] = useState(null);
  const [editData, setEditData] = useState({
    name: "",
    price: "",
    description: "",
  });

  useEffect(() => {
    const fetchProducts = async () => {
      const snap = await getDocs(collection(db, "products"));
      setProducts(snap.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    };

    fetchProducts();
  }, []);

  const uploadImage = async (file, setter) => {
    if (!file) return;

    setUploading(true);

    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", UPLOAD_PRESET);

    const res = await fetch(
      `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
      { method: "POST", body: formData }
    );

    const data = await res.json();
    setter(data.secure_url);

    setUploading(false);
  };

  const handleAddProduct = async (e) => {
    e.preventDefault();

    const newProduct = {
      name,
      price: Number(price),
      description,
      image: mainImage,
      images: [mainImage, image2, image3].filter(Boolean),
    };

    const docRef = await addDoc(collection(db, "products"), newProduct);

    setProducts([...products, { id: docRef.id, ...newProduct }]);

    setName("");
    setPrice("");
    setDescription("");
    setMainImage("");
    setImage2("");
    setImage3("");
  };

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, "products", id));
    setProducts(products.filter((p) => p.id !== id));
  };

  const handleEdit = (product) => {
    setEditingId(product.id);
    setEditData({
      name: product.name,
      price: product.price,
      description: product.description,
    });
  };

  const handleUpdate = async () => {
    await updateDoc(doc(db, "products", editingId), editData);

    setProducts((prev) =>
      prev.map((p) =>
        p.id === editingId ? { ...p, ...editData } : p
      )
    );

    setEditingId(null);
  };

  return (
    <div className="admin">

      <div className="admin-header">
        <h1>Admin Dashboard</h1>
        <p>Manage your products easily</p>
      </div>

      
      <form className="admin-form" onSubmit={handleAddProduct}>

        <input placeholder="Product Name" value={name}
          onChange={(e) => setName(e.target.value)} />

        <input type="number" placeholder="Price" value={price}
          onChange={(e) => setPrice(e.target.value)} />

        <textarea placeholder="Description" value={description}
          onChange={(e) => setDescription(e.target.value)} />

        <div className="upload-grid">
          <input type="file" onChange={(e) =>
            uploadImage(e.target.files[0], setMainImage)
          } />

          <input type="file" onChange={(e) =>
            uploadImage(e.target.files[0], setImage2)
          } />

          <input type="file" onChange={(e) =>
            uploadImage(e.target.files[0], setImage3)
          } />
        </div>

        <button disabled={uploading}>
          {uploading ? "Uploading..." : "Add Product"}
        </button>
      </form>

      {/* PRODUCTS */}
      <h2 className="section-title">Products</h2>

      <div className="product-grid">

        {products.map((p) => (
          <div className="card" key={p.id}>

            {editingId === p.id ? (
              <div className="edit-box">

                <input
                  value={editData.name}
                  onChange={(e) =>
                    setEditData({ ...editData, name: e.target.value })
                  }
                />

                <input
                  value={editData.price}
                  onChange={(e) =>
                    setEditData({ ...editData, price: e.target.value })
                  }
                />

                <textarea
                  value={editData.description}
                  onChange={(e) =>
                    setEditData({ ...editData, description: e.target.value })
                  }
                />

                <button onClick={handleUpdate}>Save</button>

              </div>
            ) : (
              <div className="card-body">

                <h3>{p.name}</h3>
                <p className="price">£{p.price}</p>
                <p className="desc">{p.description}</p>

                <div className="btn-row">
                  <button className="edit" onClick={() => handleEdit(p)}>
                    Edit
                  </button>

                  <button className="delete" onClick={() => handleDelete(p.id)}>
                    Delete
                  </button>
                </div>

              </div>
            )}

          </div>
        ))}

      </div>

    </div>
  );
};

export default AdminDashboard;